import { render } from "./ViewContainer.vue?vue&type=template&id=efe6eae6&scoped=true"
import script from "./ViewContainer.vue?vue&type=script&lang=js"
export * from "./ViewContainer.vue?vue&type=script&lang=js"

import "./ViewContainer.vue?vue&type=style&index=0&id=efe6eae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe6eae6"]])

export default __exports__